import request from '@/router/axios';

function toBladePageParams(params) {
  const p = { ...params };
  if (p.page != null) {
    p.current = p.page;
    delete p.page;
  }
  return p;
}

export const getList = (params) => {
  return request({
    url: '/api/produce/payment-order/pc/page',
    method: 'get',
    params: toBladePageParams(params),
  });
};

export const getDetail = (id) => {
  return request({
    url: '/api/produce/payment-order/detail',
    method: 'get',
    params: { id },
  });
};

/** 导出 Excel（筛选条件与列表一致，最多 10000 条） */
export const exportExcel = (params) => {
  return request({
    url: '/api/produce/payment-order/pc/export/excel',
    method: 'post',
    data: params,
    responseType: 'blob',
  });
};
